module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="DescartesPanel card" id="' +
((__t = (id)) == null ? '' : __t) +
'">\n    ';
 if(label === true) { ;
__p += '\n    <div class="card-header ' +
((__t = (panelCss)) == null ? '' : __t) +
'">\n        ';
 if(collapsible === true) { ;
__p += '\n        <a class="card-link card-title Descartes-accordion-toggle" data-toggle="collapse" data-target="#' +
((__t = (id)) == null ? '' : __t) +
'-body" href="#">\n            <span class="DescartesUITitle">' +
((__t = (title)) == null ? '' : __t) +
'</span>\n        </a>\n        ';
 } else { ;
__p += '\n        <span class="DescartesUITitle">' +
((__t = (title)) == null ? '' : __t) +
'</span>\n        ';
 } ;
__p += '\n    </div>\n    ';
 } ;
__p += '\n    \n    <div id="' +
((__t = (id)) == null ? '' : __t) +
'-body" class="collapse ';
if(!(label === true && collapsible === true && collapsed === true)){print('show');} ;
__p += '">\n        <div class="card-body">\n            ' +
((__t = (content)) == null ? '' : __t) +
'\n        </div>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/Panel.ejs
// module id = 107
// module chunks = 0